var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"ouvidoria"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.dados.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }